import React, { useCallback } from 'react'
import { type IntegrationServiceId } from '../../../../../common/integrations'
import { OnboardingIntegrationStep } from '../../../Onboarding/OnboardingIntegrationStep/OnboardingIntegrationStep'
import { Capability } from '../../../../../models/Onboarding'
import { UPCOMING_EMPTY_STATE_COPIES } from '../../../copies/onboardingCopies'
import { useTracking } from '../../../../../apps/professional-app/fa/common/tracking/hooks'
import { GrowthTrackEvent } from '../../../../../apps/professional-app/fa/common/tracking'

export interface UpcomingEmptyStateProps {
  serviceIds: IntegrationServiceId[]
  secondaryServiceIds?: IntegrationServiceId[]
  connectedWithoutSync: IntegrationServiceId[]
  postConnectRedirectPath: (serviceId: IntegrationServiceId) => string
  onDismiss: () => void
  isDismissing?: boolean
}

export const UpcomingEmptyState: React.FC<UpcomingEmptyStateProps> = ({
  serviceIds,
  secondaryServiceIds,
  connectedWithoutSync,
  postConnectRedirectPath,
  onDismiss,
  isDismissing = false,
}) => {
  const { trackingClient } = useTracking()

  const handleIntegrationSelect = useCallback(
    (serviceId: IntegrationServiceId) => {
      trackingClient.track({
        eventName: GrowthTrackEvent.UPCOMING_EMPTY_STATE_CALENDAR_INTEGRATION_CLICKED,
        eventDetails: { integrationId: serviceId },
      })
    },
    [trackingClient],
  )

  const dismissButton = (
    <button type='button' className='btn button-medium zocks-text-primary p-0' disabled={isDismissing} onClick={onDismiss}>
      {isDismissing ? 'Saving…' : 'Set up later in integrations'}
    </button>
  )

  return (
    <div className='d-flex flex-column align-items-center gap-4 w-100'>
      <OnboardingIntegrationStep
        icon={UPCOMING_EMPTY_STATE_COPIES.icon}
        headerTitle={UPCOMING_EMPTY_STATE_COPIES.headerTitle}
        headerSubtitle={UPCOMING_EMPTY_STATE_COPIES.headerSubtitle}
        serviceIds={serviceIds}
        secondaryServiceIds={secondaryServiceIds}
        secondaryServiceIdsLabel={UPCOMING_EMPTY_STATE_COPIES.secondaryServiceIdsLabel}
        connectedWithoutSync={connectedWithoutSync}
        postConnectRedirectPath={postConnectRedirectPath}
        secondaryAction={dismissButton}
        capability={Capability.CALENDAR_SOURCE}
        onIntegrationSelect={handleIntegrationSelect}
      />
    </div>
  )
}
